import {
  BpkButtonV2,
  BUTTON_TYPES,
} from '@skyscanner/backpack-web/bpk-component-button';
import { cssModules } from '@skyscanner/backpack-web/bpk-react-utils';

import AmenityGroups from '../AmenityGroups';

import type { HotelAmenityCategory } from '@shared/types/hotel-content';
import type { I18nService } from '@shared/types/i18n';

import STYLES from './AmenityHeader.module.scss';

import StickyButton from '@hotels-hotel-detail/ui/ExpandableSection/StickyButton';
import SectionHeader from '@hotels-hotel-detail/ui/SectionHeader';
import { HASH_AMENITIES } from '@shared/constants/hash-routes';
import { withHashRoutePortal } from '@shared/ui/common/HashRoute';
import RouteLink from '@shared/ui/common/RouteLink';
import FullScreenWrapper from '@shared/ui/components/FullScreenWrapper';
import { withI18n } from '@shared/ui/contexts/i18n';

const FullScreenRoute = withHashRoutePortal(FullScreenWrapper);
const cls = cssModules(STYLES);

const AmenityHeader = ({
  groups,
  i18n,
  seeMoreLess = false,
}: {
  i18n: I18nService;
  groups: HotelAmenityCategory[];
  seeMoreLess?: boolean;
}) => (
  <>
    <div className={cls('AmenityHeader')}>
      <SectionHeader title={i18n.translate('Filters_label_amenities')} />
      <div className={cls('AmenityHeader__link')}>
        <RouteLink
          href={HASH_AMENITIES}
          render={(onClickLink, linkHref) => (
            <BpkButtonV2
              href={linkHref}
              type={BUTTON_TYPES.link}
              onClick={onClickLink}
            >
              {i18n.translate('Viewed_hotels_viewAll_btn_text')}
            </BpkButtonV2>
          )}
        />
      </div>
    </div>

    <FullScreenRoute
      title={i18n.translate('Filters_label_amenities')}
      hash={HASH_AMENITIES}
      renderFooter={(onClose: () => void) => (
        <StickyButton onClick={onClose} isSubPage />
      )}
    >
      <AmenityGroups groups={groups} seeMoreLess={seeMoreLess} />
    </FullScreenRoute>
  </>
);

export default withI18n(AmenityHeader);
